module.exports = {"130672103":"白沟镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130672.json
// module id = 260
// module chunks = 0